import { Body1 } from '@sainsburys-tech/luna-typography'
import getRelativeDate from '../../../utils/getRelativeDate'
import { IReportedByDescription } from '../../../types'

const ReportedByDescription = ({ reportedBy, dateReported, timeReported }: IReportedByDescription) => {
  return (
    <div className='s-incident-report-padding'>
      <Body1
        className="ln-u-color-dark"
      >
        Reported by {reportedBy}, on {getRelativeDate({dateTime: dateReported, type:"date"})} at {getRelativeDate({dateTime: timeReported, type:"time24"})}
      </Body1>
    </div>
  )
}

export default ReportedByDescription
